module.exports = __webpack_public_path__ + "img/pixing_yj_zhaoyichen.fe3eafcd.jpg";